import {
  buildUpdateComment,
  updateCommentUsecase as _updateCommentUsecase,
} from "./update-comment";

import {
  buildFetchComment,
  fetchCommentUsecase as _fetchCommentUsecase,
} from "./fetch-comments";

import CommentRepository from "../../ports/commentRepository";

// eslint-disable-next-line import/no-anonymous-default-export
export default (dependencies: {
  commentRepo: CommentRepository;
}): {
  updateComment: _updateCommentUsecase;
  fetchComment: _fetchCommentUsecase;
} => {
  const { commentRepo } = dependencies;

  const updateComment = buildUpdateComment({ commentRepo });
  const fetchComment = buildFetchComment({ commentRepo });

  return { updateComment, fetchComment };
};

export type updateCommentUsecase = _updateCommentUsecase;
export type fetchCommentUsecase = _fetchCommentUsecase;
